import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Header.css"
import { NavLink } from "react-router-dom";
import { Button, Image } from "react-bootstrap";

function Header() {
  const menuData =[
    {
      path:"/",
      name:"Home"
    },
    {
      path:"/Track_Order",
      name:"Track Order"
    },
    {
      path:"/about",
      name:"About"
    }
  ]
  return (
    <>
      <Navbar  className="navbar" expand="lg" >
        <Container>
          <Navbar.Brand href="#home" className="brand"><Image src="logo/log.jpeg" className="img"></Image></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav variant="underline"className="ms-auto m-3 mb-lg-12">
             {
              menuData.map((item)=>(
                <NavLink to={item.path} key={item.name} className="nav">
                  <div className="list_item ps-3">{item.name}</div>

                </NavLink>
              ))
             }
            </Nav>
            <Nav className="ms-auto">
              <Button className="btn btn-success">Contact</Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
